'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { SectionWidth } from './atoms';
import { GenderToggle } from './GenderToggle';
import { LeaderboardAgeSection } from './LeaderboardAgeSection';
import { LeaderboardCard } from './LeaderboardCard';
import { LeaderboardEmptyState } from './LeaderboardEmptyState';
import { LeaderboardFooter } from './LeaderboardFooter';
import type { AgeCategoryGroup, Gender, LeaderboardEntry } from './types';
import styles from './LeaderboardList.module.css';

type LeaderboardListProps = {
  entries: LeaderboardEntry[];
  ageByCategory: AgeCategoryGroup[];
  gender: Gender;
  onGenderChange: (gender: Gender) => void;
};

export const LeaderboardList: React.FC<LeaderboardListProps> = ({
  entries,
  ageByCategory,
  gender,
  onGenderChange,
}) => {
  const t = useTranslations('performance-lab');

  return (
    <SectionWidth className={styles.listSection} aria-live="polite">
      <div className={styles.desktopControlsRow}>
        <div className={styles.toggleSlot}>
          <GenderToggle value={gender} onChange={onGenderChange} />
        </div>
        <span className={styles.unitDesktop}>
          {t('leaderboard.unit')}
        </span>
      </div>

      <div className={styles.mobileControls}>
        <div className={styles.toggleSlot}>
          <GenderToggle value={gender} onChange={onGenderChange} />
        </div>
        <span className={styles.unitMobile}>
          {t('leaderboard.unit')}
        </span>
      </div>

      {entries.length > 0 ? (
        <ol className={styles.cardList} aria-label={t('leaderboard.listAria')}>
          {entries.map((entry) => (
            <LeaderboardCard key={entry.rank} entry={entry} />
          ))}
        </ol>
      ) : (
        <LeaderboardEmptyState />
      )}

      <LeaderboardAgeSection groups={ageByCategory} />
      <LeaderboardFooter />
    </SectionWidth>
  );
};
